import React from 'react';

/**
 * in dev mode, outputs a dump of the data passed to it. in prod mode, outputs
 * null component
 *
 */
function DebugBundleItem(props) {
  const isProd = process.env.NODE_ENV === 'production';

  return isProd ? null : (
    <div className="DebugBundleItem">
      <h5>DebugBundleItem</h5>
      <h6>props</h6>
      <pre>{JSON.stringify(props, null, 2)}</pre>
      <style jsx>{`
        .DebugBundleItem {
          background: #ddd;
          border: 1px solid #666;
          padding: 0.5em;
        }
        pre {
          white-space: pre-wrap;
        }
      `}</style>
    </div>
  );
}

export default DebugBundleItem;
